import React from "react";
import Label from "../atoms/Label";
import { getIconName } from "../../util/contentModelToData";
import * as breakpoints from "../util/breakpoints";
import useMediaQuery from '../util/useMediaQuery'

export default ({ layout, icon, label, largeTitle, title }) => {
    const isMediumUp = useMediaQuery({ minWidth: breakpoints.MEDIUM });

    return <div className={ "m-icon-text" + ((layout && isMediumUp) ? " m-icon-text--row" : " u-center-text") }>
        <div className="m-icon-text__item">
            <svg role="img" className="m-icon-text__icon a-icon a-icon--xl">
                <use xlinkHref={ "/sprite.svg#sprite-" + (getIconName(icon)) }/>
            </svg>
        </div>
        <div className="m-icon-text__item">
            <Label text={ label }/>
            { (largeTitle) && <p className="m-icon-text__title u-font-variation">{ largeTitle }</p> }
            { (title) && <p>{ title }</p> }
        </div>
    </div>
}
